import React, { FC } from "react"
import { NavLink } from "react-router-dom"

export const FinancialPlanLink: FC = () => <NavLink to={"../plan"}>Plan de financement</NavLink>
